module.exports = __webpack_public_path__ + "img/img3.a7dec9e0.png";